import fetch from 'isomorphic-fetch';

import { isMac, isWindows } from 'utilities/device';
import * as sentry from 'utilities/sentry';

export const MAC_SUPPORT = 'mac';
export const WIN_SUPPORT = 'windows';

const MAC_PATH = '/v1/desktop/download/mac';
const WIN_PATH = '/v1/desktop/download/win';

export const isSupportedDesktopPlatform = () =>
  Boolean(getSupportedPlatformType());

export const getSupportedPlatformType = () => {
  if (isMac) {
    return MAC_SUPPORT;
  }

  if (isWindows) {
    return WIN_SUPPORT;
  }
};

const requestLink = url => {
  return fetch(url, { credentials: 'include' })
    .then(resp => resp.json())
    .then(({ urls }) => urls)
    .catch(err => {
      console.log('Error fetching desktop download link: ', err);
      sentry.logException(err, 'Fetch Desktop Link Error');
    });
};

export const fetchLinkByPlatform = platform => {
  if (platform === MAC_SUPPORT) {
    return requestLink(MAC_PATH);
  }

  if (platform === WIN_SUPPORT) {
    return requestLink(WIN_PATH);
  }

  return Promise.reject('Users platform not supported');
};
